export default __webpack_public_path__ + "static/media/Biene-und-Blumen.0564f6ac.webp";